import {array_unique} from "@helpers/arrays";
import {isEmpty} from "@helpers/helpers";
import ElevatorIcon from '@icons/facilities/elevator.svg';
import ParkingIcon from '@icons/facilities/parking.svg';
import WarehouseIcon from '@icons/facilities/warehouse.svg';
import TerraceIcon from '@icons/facilities/terrace.svg';
import ClosetIcon from '@icons/facilities/closet.svg';
import ToiletIcon from '@icons/facilities/toilet.svg';
import OneUnitIcon from '@icons/facilities/one_unit.svg';
import MasterBathIcon from '@icons/facilities/master_bath.svg';
import PoolIcon from '@icons/facilities/pool.svg';
import NoOwnerIcon from '@icons/facilities/no-owner.svg';
import {array_sort} from "@helpers/arrays";
import {inArray} from "../helpers/arrays";

export const FacilitiesState = {
    show: false,
    options: [
        {show: false, value: 'elevator', label: 'آسانسور', checked: false, icon: <ElevatorIcon/>},
        {show: false, value: 'parking', label: 'پارکینگ', checked: false, icon: <ParkingIcon/>},
        {show: false, value: 'warehouse', label: 'انباری', checked: false, icon: <WarehouseIcon/>},
        {show: false, value: 'terrace', label: 'تراس', checked: false, icon: <TerraceIcon/>},
        {show: false, value: 'closet', label: 'کمد دیواری', checked: false, icon: <ClosetIcon/>},
        {show: false, value: 'toilet', label: 'توالت فرنگی', checked: false, icon: <ToiletIcon/>},
        {show: false, value: 'one_unit_in_floor', label: 'تک‌واحدی', checked: false, icon: <OneUnitIcon/>},
        {show: false, value: 'without_landlord', label: 'بدون مالک', checked: false, icon: <NoOwnerIcon/>},
        {show: false, value: 'master_bath', label: 'حمام مستر', checked: false, icon: <MasterBathIcon/>},
        {show: false, value: 'pool', label: 'استخر', checked: false, icon: <PoolIcon/>},
    ],
    selected_items: [],
};
export const otherFacilityFilters = ['one_unit_in_floor', 'without_landlord'];

export const handleFacilitiesLists = (deal_type, types) => {
    let new_options = [...FacilitiesState.options];
    let facilities_show = false;
    let items = [];

    if (!isEmpty(deal_type) && types && types.length) {
        const search_facilities = getSearchFacilities(deal_type, types);
        items = items.concat(search_facilities[0]);
    }

    if (items.length) {
        items = array_unique(items);
    }

    for (let key in new_options) {
        if (items.length && items.indexOf(new_options[key].value) !== -1) {
            facilities_show = true;
            new_options[key]['show'] = true;
        } else {
            new_options[key]['show'] = false;
        }
    }

    return {
        show: facilities_show,
        options: new_options,
        selected_items: []
    }
};

export const getFacilitiesPersian = (key = null) => {
    const allFacilities = {...mainFacilities, ...otherFacilities, ...hotelUnitFacilities};
    let facilities = '';

    if (isEmpty(key)) {
        facilities = allFacilities;
    } else if (typeof key === "string" && !isEmpty(key)) {
        facilities = allFacilities[key];
    } else if (typeof key === "object" && key.length) {
        facilities = [];
        const items = array_sort(key, facilitiesSort);

        for (let item of items) {
            if (!isEmpty(allFacilities[item])) {
                facilities.push([item, allFacilities[item]]);
            }
        }
    }

    return facilities;
};

export function updateFacilitiesOptions(options, selectedData) {
    let otherFacilityFiltersSelected = [];

    const facilitiesOptions = [...options];
    for (let item of facilitiesOptions) {
        item.checked = false;
        if (inArray(item.value, selectedData)) {
            item.checked = true;
        }
    }

    for (let selected of selectedData) {
        if (inArray(selected, otherFacilityFilters)) {
            otherFacilityFiltersSelected.push(selected)
        }
    }

    return {
        options: facilitiesOptions,
        otherFacilityFilters: otherFacilityFiltersSelected
    }
}

export function getSearchFacilities(deal_type, types) {
    const deal_type_lists = {
        'sale': {
            'apartment': ['master_bath', 'elevator', 'parking', 'toilet', 'warehouse', 'pool', 'closet', 'terrace', 'one_unit_in_floor',],
            'house': [],
            'villa': [],
            'suite': [],
            'commercial': [],
            'garden': [],
            'land': [],
            'office': [],
            'hotel': [],
            'salon': [],
            'factory': [],
        },

        'rent': {
            'apartment': ['elevator', 'parking', 'warehouse', 'pool', 'closet', 'toilet', 'terrace', 'one_unit_in_floor', 'without_landlord'],
            'house': [],
            'villa': [],
            'suite': ['without_landlord'],
            'commercial': [],
            'garden': [],
            'land': [],
            'office': [],
            'hotel': [],
            'salon': [],
            'factory': [],
        },

        'mortgage': {
            'apartment': ['without_landlord', 'elevator', 'parking', 'warehouse', 'pool', 'closet', 'toilet', 'terrace', 'one_unit_in_floor',],
            'house': [],
            'villa': [],
            'suite': ['without_landlord'],
            'commercial': [],
            'garden': [],
            'office': [],
            'hotel': [],
            'salon': [],
            'factory': [],
        },

        'pre_sale': {
            'apartment': ['elevator', 'parking', 'warehouse', 'pool', 'closet', 'toilet', 'terrace', 'one_unit_in_floor',],
            'house': [],
            'villa': [],
            'suite': [],
            'commercial': [],
            'garden': [],
            'office': [],
            'hotel': [],
            'salon': [],
            'factory': [],
        },

        'participation': {
            'apartment': ['elevator', 'parking', 'warehouse', 'pool', 'closet', 'toilet', 'terrace', 'one_unit_in_floor',],
            'house': [],
            'villa': [],
            'suite': [],
            'commercial': [],
            'garden': [],
            'office': [],
            'hotel': [],
            'salon': [],
            'factory': [],
        },
    };

    let searchFieldArrays = [];
    if (deal_type && types.length > 0) {

        for (let index = 0; index < types.length; index++) {
            const type = types[index];
            if (deal_type_lists[deal_type] !== undefined && deal_type_lists[deal_type][type] !== undefined && deal_type_lists[deal_type][type].length > 0) {
                let typeSearchFields = [];
                typeSearchFields = typeSearchFields.concat(deal_type_lists[deal_type][type]);
                searchFieldArrays.push(typeSearchFields);
            }
        }
    }

    return searchFieldArrays;
}

export const FacilitiesParams = {
    'apartment': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'master_bath',
        'cctv',
        'radiator',
        'is_empty'
    ],
    'house': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'master_bath',
        'cctv',
        'radiator',
        'is_empty'
    ],
    'villa': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'water_well',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'master_bath',
        'cctv',
        'radiator',
        'is_empty'
    ],
    'commercial': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'protective_shutters',
        'bathroom',
        'pantry',
        'alarm',
        'show_case',
        'rack',
        'fire_alarm',
        'fan_coil',
        'cctv',
        'radiator'
    ],
    'office': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'pantry',
        'fire_alarm',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'cctv',
        'radiator',
        'is_empty'
    ],
    'land': [
        'wall_surrounded',
        'water_well',
    ],
    'workhouse': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'cctv',
        'radiator'
    ],
    'salon': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'cctv',
        'radiator'
    ],
    'apartment_hotel': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'restaurant',
        'main_kitchen',
        'lobby',
        'coffee_shop',
        'laundry',
        'television',
        'refrigerator',
        'oven',
        'kitchen',
        'restroom',
        'iranian_restroom',
        'furniture',
        'safe_deposit',
        'shower',
        'cctv',
        'radiator'
    ],
    'suite': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'cctv',
        'radiator',
        'is_empty'
    ],
    'garden': [
        'wall_surrounded',
        'water_well',
    ],
    'residential_complex': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'security_door',
        'desktop_gas',
        'paneled',
        'hood',
        'master_bath',
        'cctv',
        'radiator'
    ],
    'hotel': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'sauna',
        'jacuzzi',
        'pool',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'restaurant',
        'main_kitchen',
        'lobby',
        'coffee_shop',
        'laundry',
        'television',
        'refrigerator',
        'oven',
        'kitchen',
        'restroom',
        'iranian_restroom',
        'furniture',
        'safe_deposit',
        'shower',
        'cctv',
        'radiator'
    ],
    'warehouse': [
        'parking',
        'closet',
        'painted',
        'video_iphone',
        'remote_door',
        'toilet',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'cctv',
        'radiator'
    ],
    'factory': [
        'parking',
        'warehouse',
        'closet',
        'painted',
        'terrace',
        'video_iphone',
        'elevator',
        'remote_door',
        'toilet',
        'wallpaper',
        'water_cooler',
        'heater',
        'package',
        'water_heater',
        'gas_cooler',
        'heating',
        'floor_heating',
        'air_conditioning',
        'chiller',
        'cctv',
        'radiator'
    ],
};

export const mainFacilities = {
    'elevator': 'آسانسور',
    'parking': 'پارکینگ',
    'warehouse': 'انباری',
    'closet': 'کمد دیواری',
    'painted': 'نقاشی',
    'terrace': 'تراس',
    'video_iphone': 'آیفون تصویری',
    'security_door': 'درب ضد سرقت',
    'cctv': 'دوربین مداربسته',
    'remote_door': 'درب برقی',
    'toilet': 'سرویس فرنگی',
    'wallpaper': 'کاغذ دیواری',
    'desktop_gas': 'گاز رومیزی',
    'paneled': 'پانل‌کوبی',
    'hood': 'هود',
    'master_bath': 'حمام مستر',
    'pool': 'استخر',
    'sauna': 'سونا',
    'jacuzzi': 'جکوزی',

    'protective_shutters': 'کرکره محافظ',
    'bathroom': 'سرویس بهداشتی',
    'pantry': 'آبدارخانه',
    'alarm': 'دزدگیر',
    'show_case': 'ویترین',
    'rack': 'قفسه',

    'wall_surrounded': 'دور دیوار',
    'water_well': 'چاه آب',

    'fire_alarm': 'اعلام حریق',
};


export const facilitiesIcons = {
    'elevator': 'آسانسور',
    'parking': 'پارکینگ',
    'warehouse': 'انباری',
    'closet': 'کمد دیواری',
    'painted': 'نقاشی',
    'terrace': 'تراس',
    'video_iphone': 'آیفون تصویری',
    'security_door': 'درب ضد سرقت',
    'cctv': 'cctv',
    'remote_door': 'درب برقی',
    'toilet': 'سرویس فرنگی',
    'wallpaper': 'کاغذ دیواری',
    'desktop_gas': 'گاز رومیزی',
    'paneled': 'پانل‌کوبی',
    'hood': 'هود',
    'master_bath': 'حمام مستر',
    'pool': 'استخر',
    'sauna': 'سونا',
    'jacuzzi': 'جکوزی',

    'protective_shutters': 'کرکره محافظ',
    'bathroom': 'bathroom',
    'pantry': 'آبدارخانه',
    'alarm': 'alarm',
    'show_case': 'ویترین',
    'rack': 'قفسه',

    'wall_surrounded': 'دور دیوار',
    'water_well': 'چاه آب',
    'air_conditioning': 'air_conditioning',
    'fire_alarm': 'اعلام حریق',
};

export const otherFacilities = {
    'water_cooler': 'کولر آبی',
    'heater': 'بخاری',
    'package': 'پکیج',
    'radiator': 'رادیاتور',
    'water_heater': 'آبگرمکن',
    'gas_cooler': 'کولر گازی',
    'heating': 'شوفاژ',
    'floor_heating': 'گرمایش از کف',
    'air_conditioning': 'هواساز',
    'chiller': 'چیلر',
    'fan_coil': 'فن کوئل'
};

export const hotelUnitFacilities = {
    'restaurant': 'رستوران',
    'main_kitchen': 'آشپزخانه',
    'lobby': 'لابی',
    'coffee_shop': 'کافی شاپ',
    'laundry': 'لاندری',
    'television': 'تلویزیون',
    'refrigerator': 'یخچال',
    'oven': 'اجاق گاز',
    'kitchen': 'آشپزخانه',
    'toilet': 'سرویس فرنگی',
    'iranian_restroom': 'سرویس ایرانی',
    'furniture': 'مبلمان',
    'safe_deposit': 'صندوق امانات',
    'shower': 'حمام',
    'hotel_lobby': 'لابی',
    'roof_garden': 'روف گاردن',
    'sports_hall': 'سالن ورزش',
    'conference_hall': 'سالن اجتماعات',
};

export const facilitiesSort = [
    'parking',
    'warehouse',
    'closet',
    'painted',
    'terrace',
    'video_iphone',
    'elevator',
    'remote_door',
    'toilet',
    'wallpaper',
    'sauna',
    'pool',
    'water_cooler',
    'heater',
    'package',
    'water_heater',
    'gas_cooler',
    'heating',
    'floor_heating',
    'air_conditioning',
    'chiller',
    'protective_shutters',
    'bathroom',
    'pantry',
    'alarm',
    'show_case',
    'rack',
    'wall_surrounded',
    'water_well',
    'fire_alarm',
    'fan_coil',
    'restaurant',
    'main_kitchen',
    'lobby',
    'coffee_shop',
    'laundry',
    'television',
    'refrigerator',
    'oven',
    'kitchen',
    'restroom',
    'iranian_restroom',
    'furniture',
    'safe_deposit',
    'shower',
    'security_door',
    'cctv',
    'paneled',
    'desktop_gas',
    'hood',
    'master_bath',
    'jacuzzi',
    'radiator',
];